import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/app-menu";

// ================= CATEGORY SERVICES =================

export const ListCategories = async (values) => {
  return await axiosInstance(options).post(`${path}/category/list`, values);
};

export const AddCategory = async (values) => {
  return await axiosInstance(options).post(`${path}/category/add`, values);
};

export const EditCategory = async (values) => {
  return await axiosInstance(options).put(`${path}/category/edit`, values);
};

export const DeleteCategory = async (values) => {
  return await axiosInstance(options).post(`${path}/category/delete`, values);
};

export const CategoryDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/category/details?o_id=${id}`);
};

export const ChangeCategoryStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/category/change-status`, values);
};

// ================= ITEM SERVICES =================

export const ListItems = async (values) => {
  return await axiosInstance(options).post(`${path}/item/list`, values);
};

export const AddItem = async (values) => {
  return await axiosInstance(options).post(`${path}/item/add`, values);
};

export const EditItem = async (values) => {
  return await axiosInstance(options).put(`${path}/item/edit`, values);
};

export const DeleteItem = async (values) => {
  return await axiosInstance(options).post(`${path}/item/delete`, values);
};

export const ItemDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/item/details?o_id=${id}`);
};

export const ChangeItemStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/item/change-status`, values);
};
